'use client';

import { createContext, useContext } from "react";

export const OrgContext = createContext(null);
export const useOrg = () => {
  const v = useContext(OrgContext);
  if (!v) throw new Error("useOrg used outside <OrgSettingsModule>.");
  return v;
};

export const defaultCopy = {
  page_title: "Organisation settings",
  page_subtitle: "Your business details — used across the app and on your messages.",
};

export const errText = (e) =>
  e?.response?.data?.detail || e?.message || "Something went wrong. Please try again.";
